import { Clock4 } from 'lucide-react';

const ProjectBlob = (props) => {
    
    var local = new Date(props.project.due_date);
    var offset = local.getTimezoneOffset();
    var due_date = new Date(local.getTime() + offset * 60000);

    function convertCurrencyToDouble(currency, locale = 'en-US', currencyType = 'USD') {
        // Creating a NumberFormat object with specified locale and currency
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyType,
            currencyDisplay: 'symbol'
        });
    
        // Formatting the currency to remove any non-numeric characters except for decimal point
        const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
    
        // Converting the normalized string to a double value using Number constructor
        const doubleValue = Number(normalizedCurrency);
    
        // Returning the double value
        return doubleValue;

    }

    const fee = convertCurrencyToDouble(props.project.fee)
    const paid = convertCurrencyToDouble(props.project.paid)

    let statusColor = (function () {
        switch (props.project.status){
            case "Not Started":
                return "not_started"
                break;
            case "Awaiting Assets":
                return "assets"
                break;
            case "In Progress":
                return "wip"
                break;
            case "Awaiting Feedback":
                return "feedback"
                break;
            case "Revising":
                return "revising"
                break;
            case "Mastering":
                return "mastering"
                break;
            case "Delivering":
                return "delivering"
                break;
            case "Complete":
                return "complete"
                break;
            default:
                return ""
        }
    })();

    return (
        // <div className="projectBlob">
        //     <div className="blobLeft">
        //         <span>
        //             {props.project.client}
        //         </span>
        //         <h4 className="text-black">
        //             {props.project.title}
        //         </h4>
        //     </div>
        //     <div className="blobRight">
        //         <div className={statusColor+ " alignRight"} id="status">
        //             {props.project.status}
        //         </div>
        //         <div className="alignRight" id="due_date">
        //             Due: {due_date.toDateString()}
        //         </div>
        //         <div className="alignRight" id="blobPaid">
        //             {((paid>=fee) )? "Paid" : ""}
        //         </div>
        //     </div>
        // </div>

        <div className="projectBlob ">
            <div className="blobTop">
                <div className="blobTitle">
                    <span>
                        {props.project.client}
                    </span>
                    <h4 className="text-black">
                        {props.project.title}
                    </h4>
                </div>
                <div className="alignRight" id="due_date">
                    &nbsp; Due  {due_date.toDateString()}
                </div>
            </div>
            <div className="blobBottom">
                <div className={statusColor+ " alignRight"} id="status">
                    {props.project.status}
                </div>
                {/* <div className="alignRight" id="blobPaid">
                    {((paid>=fee) )? "Paid" : ""}
                </div> */}
                {paid>=fee ? 
                <div className="alignRight" id="blobPaid"> 
                    Paid
                </div>
                : 
                <></> }
            </div>
        </div>
    )
}

export default ProjectBlob